import { Component, OnInit } from '@angular/core';
import { DeviceDetectorService } from 'ngx-device-detector';

import { AbstractBiditComponent } from '../../../shared/controls/abstract.bidit.component';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { AdminService } from '../../services/admin.service';
import { FileService } from '../../../shared/services/file.service';
import { FileUpload } from '../../../shared/models/file.upload.interface';
import { ImportExtermalItemErrors, ImportExternalItemData } from '../models/import-external-item.interface';


@Component({
  selector: 'app-import-item-source',
  standalone: false,
  templateUrl: './import-item-source.component.html',
  styleUrl: './import-item-source.component.scss'
})
export class ImportItemSourceComponent extends AbstractBiditComponent implements OnInit {
  displayedColumns: string[] =
    ['itemName', 'itemSalesDesc', 'rValue', 'itemTypeDesc', 'cost', 'sqrFtPerUnit', 'costPerSqrFt', 'costPerSqrFtOverage', 'sqrFtUptoOverage', 'origMfgPart', 'mfrPart', 'itemMessage'];

  failedItems: ImportExternalItemData[] = [];
  fileSelected: boolean = false;
  fileBytes?: string;
  importFile?: any;
  importComplete: boolean = false;
  file: FileUpload;
  dataSource = this.failedItems;
  isRequesting

  constructor(private dialog: MatDialog, protected adminService: AdminService,
    private fileService: FileService,
    public dialogRef: MatDialogRef<ImportItemSourceComponent>,
    private deviceDetectorService: DeviceDetectorService) {
    super(deviceDetectorService);
  }

  ngOnInit() {
    this.isRequesting = false;
    this.errors = '';
  }

  importItem() {
    this.errors = '';

    if (this.fileBytes === undefined) {
      this.errors = 'File is required';
      return;
    }

    this.isRequesting = true;

    // Set File Information
    this.file = {
      fileName: this.importFile.name,
      fileSize: this.importFile.size,
      fileType: this.importFile.type,
      lastModifiedTime: this.importFile.lastModified,
      lastModifiedDate: this.importFile.lastModifiedDate,
    } as FileUpload;

    this.file.fileAsBase64 = this.fileBytes;

    if (this.fileBytes.length > 0) {
      this.fileSelected = true;
      this.errors = '';
    }

    /*  POST to server*/
    this.adminService.importExternalItemSource(this.file)
      .subscribe({
        next: (resp) => {
          this.errors = "Upload complete";

          this.failedItems = resp;
          this.dataSource = this.failedItems;
          this.isRequesting = false;
          this.importComplete = true;
          if (this.failedItems.length === 0) {
            this.dialogRef.close(true);
          }
        },
        error: (error: string) => {
          this.isRequesting = false;
          alert($localize`Error - Unable to import file. Only .csv and .xlsx format files are supported.`);
        }
      });
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  exportErrors() {
    let dealerId = this.adminService.getDealerId();
    this.isRequesting = true;

    let split = this.file.fileName.split('.');
    split.pop();
    let finalName = `${split[0]}-Errors.csv`;

    let errorRequest: ImportExtermalItemErrors = { dealerId: dealerId, failedItems: this.failedItems }

    this.adminService.exportItemImportErrorsList(this.failedItems)
      .subscribe({
        next: (data) => {
          this.isRequesting = false;
          this.fileService.downloadFile(data, finalName);
          this.dialogRef.close(true);
        },
        error: (error: string) => this.onError(error)
      });
  }
}
